"use client";
import { useState, useEffect, useCallback } from "react";
import { atom, useAtom } from "jotai";
const debounce = (fn: Function, ms: number) => {
  let timer: any;
  return function () {
    clearTimeout(timer);
    timer = setTimeout(function () {
      timer = null;
      //@ts-ignore
      fn.apply(this, arguments);
    }, ms);
  };
};
export const WindowWidthAtom = atom(0);

export const useWindowDimension = () => {
  const [, setDimension] = useAtom(WindowWidthAtom);
  useEffect(() => {
    const debouncedResizeHandler = debounce(() => {
      setDimension(window?.innerWidth);
    }, 100);
    window?.addEventListener("resize", debouncedResizeHandler);
    setDimension(window?.innerWidth);
    return () => {
      window?.removeEventListener("resize", debouncedResizeHandler);
    };
  }, []);
};

function getDimensionObject(node: any) {
  const rect = node.getBoundingClientRect();

  return {
    width: rect.width,
    height: rect.height,
    top: "x" in rect ? rect.x : rect.top,
    left: "y" in rect ? rect.y : rect.left,
    x: "x" in rect ? rect.x : rect.left,
    y: "y" in rect ? rect.y : rect.top,
    right: rect.right,
    bottom: rect.bottom,
  };
}

export function useDimensions(data = null, liveMeasure = true) {
  const [dimensions, setDimensions] = useState<any>({});
  const [node, setNode] = useState(null);

  const ref = useCallback((node: any) => {
    setNode(node);
  }, []);

  useEffect(() => {
    if (node) {
      const measure = () =>
        window.requestAnimationFrame(() =>
          setDimensions(getDimensionObject(node)),
        );
      measure();

      if (liveMeasure) {
        window?.addEventListener("resize", measure);
        window?.addEventListener("scroll", measure);

        return () => {
          window?.removeEventListener("resize", measure);
          window?.removeEventListener("scroll", measure);
        };
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [node, data]);

  return [ref, dimensions, node];
}
